<template>
<!-- 联盟审核 -->
<section class="viewContainer">
  <div v-if="showList">
    <!-- 搜索/查询 -->
    <div class="main_container">
      <div class="fuji" @click="show3 = !show3">
        <div class="goodslist1">
          <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
          <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
        </div>
        <div style="position: absolute;right:0;top:-10px" class="sanjiao"/>
      </div>
      <!-- 顶部搜索框 -->
      <el-collapse-transition>
      <div v-show="show3">
        <el-form :inline="true" :model="filters" style="margin-top:10px;display:flex;" class="findform">
          <el-form-item label="关键词语：" style="display:flex;width:30%">
            <el-input :title="filters.keyword" v-model="filters.keyword" placeholder="搜索联盟名称·联系人·电话"
             maxlength="50" style="width:90%"/>
          </el-form-item>
          <!-- <el-form-item style="display:flex;width:100%" label="会员卡：">
            <el-input v-model="filters.vipCardName" placeholder="请输入会员卡名称"/>
          </el-form-item> -->
          <el-form-item label="状态：" style="display:flex;width:30%">
            <el-select v-model="filters.vipOrderStatusId" placeholder="请选择" style="width:90%" ref="mySelect">
              <el-option v-for="(item,index) in statusoptions" :key="index" :label="item.Name" :value="item.Id"/>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="danger" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      </el-collapse-transition>
    </div>
    <div class="main_container">
      <section class="model_section">
        <p class="model_top_title">联盟审核</p>
      </section>
      <!-- table 列表 -->
      <div class="table_container">
        <el-table :data="dataList" stripe border>
          <el-table-column label="序号" align="center" width="50">
            <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
          </el-table-column>
          <el-table-column label="盟主店铺" align="center">
            <template scope="scope">
              <span class="spanList" :title="scope.row.bbName">{{ scope.row.bbName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="城市" align="center">
            <template scope="scope">{{scope.row.cityName}}</template>
          </el-table-column>
          <el-table-column label="联盟名称" align="center">
            <template scope="scope">
              <span class="spanList" :title="scope.row.name">{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="LOGO" align="center">
            <template scope="scope">
              <el-image :src="scope.row.logoUrl" alt="" class="logoImg" @click="handleClickItem" :preview-src-list="[scope.row.logoUrl]"/>
            </template>
          </el-table-column>
          <el-table-column label="联盟联系人" align="center">
            <template scope="scope">{{scope.row.contacts}}</template>
          </el-table-column>
          <el-table-column label="联系电话" align="center">
            <template scope="scope">{{scope.row.contactsPhone}}</template>
          </el-table-column>
          <el-table-column label="申请时间" align="center" width="160">
            <template scope="scope">{{scope.row.time}}</template>
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template scope="scope">{{scope.row.stateName}}</template>
          </el-table-column>
          <el-table-column label="审核备注" align="center">
            <template scope="scope">{{scope.row.examineRemarks}}</template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center" width="200">
            <template scope="scope">
              <span v-if="scope.row.state == 1" @click="showSettlement(scope.row.id,true)" class="handle">
                <i class="el-icon-circle-check"></i> 通过
              </span>
              <span v-if="scope.row.state == 1" @click="showSettlement(scope.row.id,false)" class="handle">
                <i class="el-icon-circle-close"></i> 拒绝
              </span>
              <span v-if="scope.row.state == 2" @click="seeOrder(scope.row)" class="handle">
                <i class="el-icon-view"></i>查看
              </span>
              <span v-if="scope.row.state == 2" @click="kaiqiguanbi(scope.row.id,scope.row.isSeeAll == false?true:false)" style="color: #3396fb;">
                <i class="el-icon-data-line"></i> {{ scope.row.isSeeAll == false?'开数据':'关数据' }}
              </span>
            </template>
          </el-table-column>
        </el-table>
        <!-- <div class="copywriting">
          <p> 平台佣金 </p>
          <p>1、会员用户消费：实付金额*会员所消费品牌平台抽佣比例-优惠券面值*优惠券设置的品牌商返佣比例</p>
          <p>2、非会员用户消费：实付金额*固定佣金比例-优惠券面值*优惠券设置的品牌商返佣比例</p>
        </div> -->
        <!--分页-->
        <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
        :current-page="pageIndex" :page-size="10" :total="total" style="margin:10px 0;float:right"/>
      </div>
    </div>
  </div>

  <div v-if="!showList">
    <div class="main_container">
      <p class="reminder" style="padding:10px">
        <img :src="seeLogoUrl" class="faceUrl"/> 联盟名称: {{seeName}}　　联盟联系人: {{seeContacts}}　　联系电话: {{seePhone}}
      </p>
      <!-- 顶部搜索框 -->
      <el-form :model="filters" style="display:flex;margin-left: 16px;">
        <el-form-item style="display:flex;width:30%">
          <el-input v-model="keyWordTwo" placeholder="搜索店铺名称" maxlength="20" style="width:90%;"/>
        </el-form-item>
        <el-form-item> <el-button type="danger" @click="onSubmitTwo">查询</el-button> </el-form-item>
      </el-form>
    </div>
    
    <div class="main_container">
      <section class="model_section">
        <p class="model_top_title">审核详情列表</p>
      </section>
      <div class="table_container">
        <el-table :data="dataListTwo" stripe border>
          <el-table-column label="序号" align="center" width="50">
            <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
          </el-table-column>
          <el-table-column label="店铺名称" align="center">
            <template scope="scope">
              <span class="spanList" :title="scope.row.name">{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column label="负责人" align="center">
            <template scope="scope">{{scope.row.contacts}}</template>
          </el-table-column>
          <el-table-column label="联系电话" align="center">
            <template scope="scope">{{scope.row.phone}}</template>
          </el-table-column>
          <el-table-column label="店铺类型" align="center">
            <template scope="scope">{{scope.row.bbTypeName}}</template>
          </el-table-column>
          <el-table-column label="加入时间" align="center">
            <template scope="scope">{{scope.row.cTime}}</template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <el-pagination layout="prev, pager, next" @current-change="handleCurrentChangeTwo"
        :current-page="pageIndexTwo" :page-size="10" :total="totalTwo" style="margin:10px 0;float:right"/>
      </div>
      <div style="width: 100%;text-align: center;margin-bottom: 20px;display: flow-root;"><el-button @click="returnFun">返回</el-button></div>
    </div>
  </div>
  <!-- 审核备注弹框 -->
  <el-dialog :center="true" title="审核" :visible.sync="importantIips" width="30%">
    <el-form class="findform">
      <el-form-item style="display:flex;width:100%" label="审核备注：">
        <el-input v-model="remarks" placeholder="请输入审核意见" maxlength="50"
          style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"/>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="danger" @click="gonext()">确定</el-button>
      <el-button @click="importantIips = false">取 消</el-button>
    </div>
  </el-dialog>
</section>
</template>
<script>
import { examineMAList, examine, merchantAllianceEdit, merchantAllianceTree,
merchantAllianceNotInMyMA, merchantAllianceInvitation, merchantAllianceMy,
cancelInvitation, myMerchantAllianceList, agreeJoinMA,
refuseJoinMA, seeMABase, seeMAList, putSeeAll } from "../../api/attractInvestment";
export default {
  name: 'transactionsPlatform',
  props: ["menuAction"],
  data() {
    return {
      show3: true,
      importantIips: false, // 备注弹框
      remarks: '', // 备注内容
      showList: false, // 初始现实审核列表，false显示查看列表
      dialog: false, // 抽屉详情
      dataList: [], // 查询列表
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      statusoptions: [
        {
          Name: '全部',
          Id: '0',
        },
        {
          Name: '待审核',
          Id: '1',
        },
        {
          Name: '已通过',
          Id: '2',
        },
        {
          Name: '已驳回',
          Id: '3',
        },
      ],
      filters: {
        keyword: "",
        vipOrderStatusId: '0', // 状态
      },
      queryId: '',
      keyWordTwo: '',     //查看-搜索关键字
      totalTwo: 0,
      pageIndexTwo: 1,
      dataListTwo: [],
      seeLogoUrl:'',
      seeName: '',
      seeContacts: '',
      seePhone: '',
      maId: '',
    }
  },
  methods: {
    // 审核弹框确定按钮
    gonext(){
      let addParams = {
        maId: this.maId,
        state: this.passOrReject?2:3,
        remark: this.remarks,
        userId: localStorage.Id, // 当前操作人id
      };
      examine(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.$swal({
              type:"success",
              text:data.resultMsg
            })
            this.getorder();
            this.importantIips = false;
          }
        }
      })
      .catch(err => {
      });
    },
    //查询列表
    getorder() {
      let that = this;
      let addParams = {
        userId: localStorage.Id, // 当前操作人id
        key: this.filters.keyword,
        pageIndex: this.pageIndex, // 分页数据 当前页码
        pageSize: 10, // 分页数据 每页显示条数
        state: that.filters.vipOrderStatusId, // 状态
      };
      examineMAList(addParams).then(data => {
          if (data) {
            if (data.resultCode == 1) {
                data.resultObj.resultObj.forEach(item=>{
                  item.stateName = item.state==1?'待审核':item.state==2?'已通过':'已驳回';
                })
                this.dataList = data.resultObj.resultObj;
                this.total = data.resultObj.rowsCount;
            } else {
                this.dataList = []
            }
          } else {
            this.dataList = []
          }
        })
        .catch(err => {
          this.dataList = [];
        });
    },
    //查看，联盟绑定店铺列表 
    getorderTwo() {
      let that = this;
      var addParams = {
        maId: this.maId,
        key: this.keyWordTwo,
        pageIndex: this.pageIndexTwo,
        pageSize: 10
      };
      seeMAList(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
              data.resultObj.resultObj.forEach(item=>{
                item.bbTypeName = item.bbType==1?'品牌建材 ':'装修公司';
              })
              this.dataListTwo = data.resultObj.resultObj;
              this.totalTwo = data.resultObj.rowsCount;
          } else {
              this.dataListTwo = []
          }
        } else {
          this.dataListTwo = []
        }
      })
      .catch(err => {
        this.dataListTwo = [];
      });
    },
    // 查看
    seeOrder(row) {
      this.showList = false;
      this.maId = row.id;
      this.seeLogoUrl = row.logoUrl;
      this.seeName = row.name;
      this.seeContacts = row.contacts;
      this.seePhone = row.contactsPhone;
      this.getorderTwo();
    },
    // 开启数据 & 关闭数据
    kaiqiguanbi(rowId, valType) {
      this.maId = rowId;
      this.$swal({
        type: "warning",
        text: valType == false ? "是否执行关闭操作" : "是否执行开启操作",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          this.makesure(valType);
        }
      });
    },
    // 确定执行操作--调取开启关闭接口
    makesure(valType) {
      let obj = {
        isSeeAll: valType,
        id: this.maId
      }
      putSeeAll(obj).then(data=>{
        if(data.resultCode == 1){
          this.getorder();
          this.$swal({
            type:"success",
            text:"操作成功"
          })
        }
      })
    },
    // 点击返回按钮
    returnFun(){
      this.showList = true;
    },
    // 通过/拒绝按钮
    showSettlement(id,state) {
      this.maId = id;
      this.passOrReject = state;    //判断是通过还是拒绝，true通过，false拒绝
      this.remarks = '';
      this.importantIips = true;
    },
    //查询
    onSubmit() {
      this.pageIndex = 1;
      this.getorder();
    },
    //查看-查询
    onSubmitTwo() {
      this.pageIndexTwo = 1;
      this.getorderTwo();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getorder();
    },
    // 分页
    handleCurrentChangeTwo(val) {
      this.pageIndexTwo = val;
      this.getorderTwo();
    },
    // 关闭el-image遮罩层
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
  },
  created() {
    this.showList = true;
    let that = this;
    // 查询列表
    setTimeout(function() {
      that.getorder();
    }, 200);
    this.queryId = this.$route.query.consumptionUserId;
  }
  // activated() {
  //   let that = this;
  // }
}
</script>
<style>
.el-drawer__body {
  overflow: scroll;
}
.el-drawer__header {
  margin-bottom: 15px;
}
</style>
<style scoped>
/* 表格操作 */
.action_container {
  color: #677c9d;
  cursor: pointer;
}
.drawer_title {
  padding-left: 0;
  display: flex;
  justify-content: space-between;
}
.drawer_title>li:first-child{
  font-size: 18px;
  font-weight: bolder;
  color: #333;
}
.drawer_div {
  width: 96%;
  margin: 0 auto;
}
.drawer_ul:first-child {
  border-bottom: 2px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 5px;
}
.drawer_ul>li {
  line-height: 40px;
  font-size: 16px;
}
.drawer_ul>li>span {
  font-size: 15px;
}
.drawer_ul>li>span>img {
  width: 66px;
  height: 66px;
  margin-left: 10px;
  margin-bottom: 10px;
}
.watch_first {
  display: inline-block;
  color: #888;
  min-width: 90px;
  text-align: justify;
  text-align-last: justify;
}
.drawer_foot {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 10px;
}
.copywriting {
  width:80%;
  float:left;
  margin-top:15px;
  margin-left:20px;
}


.faceUrl{
  width: 40px; 
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
}
.logoImg{
  width: 30px;
  height: 30px;
}
.handle{
  padding: 0 5px;
}
</style>


// WEBPACK FOOTER //
// merchantAllianceAudit.vue?d07bc844